import {isAssignableTo, maybe, type Type} from '@wandb/weave/core';
import {useMemo} from 'react';

import {TABLE_FILE_TYPE} from '../../../common/types/file';
import {type PanelStepperConfigType} from './types';
import {getDefaultWorkingKeyAndType} from './util';

export const useTableSelection = (
  propertyKeysAndTypes: {
    [key: string]: Type;
  },
  config: PanelStepperConfigType | undefined,
  safeUpdateConfig: (updates: Partial<PanelStepperConfigType>) => void
) => {
  return useMemo(() => {
    const tableKeys = Object.keys(propertyKeysAndTypes).filter(key => {
      if (key === '<none>') {
        return false;
      }
      const keyType = propertyKeysAndTypes[key];
      return isAssignableTo(keyType, maybe(TABLE_FILE_TYPE));
    });

    const shouldShow =
      config?.tableSelection?.show === true || tableKeys.length > 0;

    if (!shouldShow) {
      return {
        show: false,
        keys: [],
        currentSelection: undefined,
        callback: () => {},
      };
    }

    const {key: defaultKey} = getDefaultWorkingKeyAndType(
      config,
      propertyKeysAndTypes
    );

    return {
      show: true,
      keys: tableKeys,
      currentSelection: defaultKey ?? tableKeys[0],
      callback: (key: string) => {
        safeUpdateConfig({
          workingKeyAndType: {
            key,
            type: propertyKeysAndTypes[key],
          },
        });
      },
    };
  }, [propertyKeysAndTypes, config, safeUpdateConfig]);
};
